export default function EFWhatsApp(props: any) {
    return (
        <svg
            width="16px"
            height="16px"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="check-list" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="check-list-C-3" transform="translate(-1094.000000, -785.000000)" stroke="#FFFFFF" strokeWidth="1.4">
                    <g id="button备份" transform="translate(790.000000, 769.000000)">
                        <g id="编组-2" transform="translate(21.000000, 12.000000)">
                            <g id="编组" transform="translate(284.000000, 5.000000)">
                                <rect id="矩形" x="0" y="0" width="10.8888889" height="10.8888889" rx="2"></rect>
                                <rect id="矩形备份-2" fill="#26C41A" x="3.18888889" y="3.11111111" width="10.8888889" height="10.8888889" rx="2"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
